import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from 'components/pages/Home/Home';
import Login from 'components/pages/Login';
import { SnackbarProvider } from 'notistack';
import Dashboard from 'components/pages/Dashboard';
import Orders from 'components/pages/Orders';
import PurchaseOrders from 'components/pages/PurchaseOrders';
import DispatchesReports from 'components/pages/DispatchesReports';
import SchedulePickup from 'components/pages/SchedulePickup';
import NotFoundPage from 'components/pages/NotFound';
import Warehouse from 'components/pages/Warehouse';
import Packages from 'components/pages/Packages';
import OrderTracking from 'components/pages/OrderTracking';
import Refund from 'components/pages/Refund';
import IMInventoryEntry from 'components/pages/IMInventoryEntry';
import IMAdjustment from 'components/pages/IMAdjustment';

// Inventory Managment
import IMWarehouse from 'components/pages/IMWarehouse';
import IMCategories from 'components/pages/IMCategories';
import IMCategoriesPromotion from 'components/pages/IMCategoriesPromotion';
import IMProviders from 'components/pages/IMProviders';
import IMProducts from 'components/pages/IMProducts';
import IMInventoryOutput from 'components/pages/IMInventoryOutput';
import CrossingInvoices from 'components/pages/CrossingInvoices';

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <Router>
        <Switch>
          <Route path="/" component={Login} exact />
          <Route path="/home" component={Home} exact />
          <Route path="/login" component={Login} />
          <Route path="/admin/dashboard" component={Dashboard} exact />
          <Route path="/admin/orders" component={Orders} exact />
          <Route path="/admin/purchaseOrders" component={PurchaseOrders} exact />
          <Route path="/admin/crossingInvoices" component={CrossingInvoices} exact />
          <Route path="/admin/dispatchesReports" component={DispatchesReports} exact />
          <Route path="/admin/orderTracking" component={OrderTracking} exact />
          <Route path="/admin/schedule" component={SchedulePickup} exact />
          <Route path="/admin/warehouse" component={Warehouse} exact />
          <Route path="/admin/packages" component={Packages} exact />
          <Route path="/admin/refund" component={Refund} exact />
          <Route path="/admin/inventoryManagement/IMWarehouse" component={IMWarehouse} exact />
          <Route path="/admin/inventoryManagement/IMCategories" component={IMCategories} exact />
          <Route path="/admin/inventoryManagement/IMCAPromotion" component={IMCategoriesPromotion} exact />
          <Route path="/admin/inventoryManagement/IMProviders" component={IMProviders} exact />
          <Route path="/admin/inventoryManagement/IMProducts" component={IMProducts} exact />
          <Route path="/admin/inventoryManagement/IMInventoryEntry" component={IMInventoryEntry} exact />
          <Route path="/admin/inventoryManagement/IMInventoryOutput" component={IMInventoryOutput} exact />
          <Route path="/admin/inventoryManagement/IMAdjustment" component={IMAdjustment} exact />
          <Route path="/admin" component={Dashboard} exact />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
